import { render, staticRenderFns } from "./FeedbackModal.vue?vue&type=template&id=4ae6be44&scoped=true&"
import script from "./FeedbackModal.vue?vue&type=script&lang=ts&"
export * from "./FeedbackModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae6be44",
  null
  
)

export default component.exports